module.exports = __webpack_public_path__ + "static/media/apkicon.32e54944.jpg";